export default "__VITE_ASSET__BJY3UP7T__"